import React from 'react';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import ResponsiveTable from '../../../components/common/ResponsiveTable';
import { Edit as EditIcon, Delete as DeleteIcon, Category as CategoryIcon, ContentCopy as ContentCopyIcon } from '@mui/icons-material';

const typeLabels = {
  development: 'Ανάπτυξη',
  hosting: 'Hosting',
  saas: 'SaaS',
  maintenance: 'Συντήρηση',
  custom: 'Custom',
};

const QuotePackageTable = ({
  data,
  loading,
  onEdit,
  onDelete,
  onDuplicate,
  onManageSections,
}) => {
  const columns = [
    {
      field: 'name',
      headerName: 'Όνομα',
      minWidth: 220,
      sortable: false,
      renderCell: (value, row) => (
        <Box>
          <Typography variant="subtitle2">{value}</Typography>
          {row.description && (
            <Typography variant="caption" color="text.secondary">
              {row.description}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: 'package_type',
      headerName: 'Τύπος',
      minWidth: 120,
      sortable: false,
      renderCell: (value) => (
        <Chip label={typeLabels[value] || value} size="small" color="info" variant="outlined" />
      ),
    },
    {
      field: 'is_active',
      headerName: 'Κατάσταση',
      minWidth: 120,
      sortable: false,
      renderCell: (value) => (
        <Chip
          label={value ? 'Ενεργό' : 'Ανενεργό'}
          size="small"
          color={value ? 'success' : 'default'}
        />
      ),
    },
    {
      field: 'sections',
      headerName: 'Ενότητες',
      minWidth: 140,
      sortable: false,
      renderCell: (value, row) => (
        <Chip
          icon={<CategoryIcon fontSize="small" />}
          label={`${row.sections?.length || 0} ενότητες`}
          size="small"
          variant="outlined"
          color="primary"
        />
      ),
    },
    {
      field: 'actions',
      headerName: 'Ενέργειες',
      minWidth: 140,
      sortable: false,
      renderCell: (value, row) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Διαχείριση Ενοτήτων">
            <IconButton size="small" color="primary" onClick={() => onManageSections(row)}>
              <CategoryIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Επεξεργασία">
            <IconButton size="small" onClick={() => onEdit(row)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Αντιγραφή">
            <IconButton size="small" color="info" onClick={() => onDuplicate(row)}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Διαγραφή">
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <ResponsiveTable
      data={data}
      columns={columns}
      loading={loading}
      emptyMessage="Δεν υπάρχουν πακέτα προσφορών"
      renderMobileCard={(row) => (
        <Box key={row.id} sx={{ p: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle1" fontWeight={600}>
              {row.name}
            </Typography>
            <Chip
              label={row.is_active ? 'Ενεργό' : 'Ανενεργό'}
              size="small"
              color={row.is_active ? 'success' : 'default'}
            />
          </Box>
          {row.description && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {row.description}
            </Typography>
          )}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 1 }}>
            <Chip label={typeLabels[row.package_type] || row.package_type} size="small" color="info" variant="outlined" />
            <Chip
              icon={<CategoryIcon fontSize="small" />}
              label={`${row.sections?.length || 0} ενότητες`}
              size="small"
              variant="outlined"
              color="primary"
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
            <IconButton size="small" color="primary" onClick={() => onManageSections(row)}>
              <CategoryIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => onEdit(row)}>
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" color="info" onClick={() => onDuplicate(row)}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      )}
    />
  );
};

export default QuotePackageTable;

